export default "__VITE_ASSET__d0b7e899__"